import { copy } from 'utils/constants/copy';

// Elective egg freezing eligibility for the market this build serves. The eligibility
// notice only appears when all three are set at build time (the lower age is inclusive,
// the upper age is exclusive), so a build without them carries no location-specific copy:
//   REACT_APP_ELIGIBILITY_REGION=Singapore
//   REACT_APP_ELIGIBILITY_MIN_AGE=21
//   REACT_APP_ELIGIBILITY_MAX_AGE=38
const toNumber = (value?: string): number | undefined => {
  const n = value ? Number(value) : NaN;

  return Number.isFinite(n) ? n : undefined;
};

const region = process.env.REACT_APP_ELIGIBILITY_REGION || undefined;
const minAge = toNumber(process.env.REACT_APP_ELIGIBILITY_MIN_AGE);
const maxAge = toNumber(process.env.REACT_APP_ELIGIBILITY_MAX_AGE);

export const hasEligibility =
  !!region && minAge !== undefined && maxAge !== undefined;

// Whether the entered age falls outside the eligible range.
export const isOutsideEligibility = (age: string | number): boolean =>
  hasEligibility &&
  !!+age &&
  (+age < (minAge as number) || +age >= (maxAge as number));

export const getEligibilityText = (age: string | number): string => {
  if (!hasEligibility) {
    return '';
  }

  const template = isOutsideEligibility(age)
    ? copy.eligibilityAge
    : copy.eligibility;

  return template
    .replace('{age}', `${age}`)
    .replace('{region}', region as string)
    .replace('{min}', `${minAge}`)
    .replace('{max}', `${maxAge}`);
};
